import { render } from "./liveView.vue?vue&type=template&id=658e6a70"
import script from "./liveView.vue?vue&type=script&lang=js"
export * from "./liveView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__